import { inject, Injectable } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { CommandService, Flow, HasCommands } from "../../command/command.service";
import { CommandInput, CommandTemplate } from "../../../entities/commandTemplate/commandTemplate";
import { EditDialogService } from "../../../components/editDialog/editDialogService";
import { IssueCreateDialogComponent } from "../../../components/issue-create-dialog/issue-create-dialog.component";
import { Issue } from "../../../entities/issue/issue";
import { RefetchCoordinator } from "../../refetch-coordinator/refetch-coordinator.service";

@Injectable({
    providedIn: 'root'
  })
export class IssueCreateCommandCustomFlow implements Flow {

  dialogRef: DynamicDialogRef | undefined;

  private refetchCoordinator = inject(RefetchCoordinator);

  constructor(
    private dialogService: EditDialogService
  ) { }

  executeFlow(commandService: CommandService, hasCommands: HasCommands,
    commandTemplate: CommandTemplate, commandInput: CommandInput,
    completionCallback: () => void) {

      this.dialogRef = this.dialogService.open(IssueCreateDialogComponent, {
        width: "900px",
        header: "Vorgang erstellen",
        data: {
          commandTemplate: commandTemplate,
        }
      });
      this.dialogRef.onClose.subscribe((result) => {
        if(result){
          commandInput.addParameter("issueInput", result);
          commandService.sendCommand(commandInput, () => {
             this.refetchCoordinator.emit({ entityType: Issue.ENTITY_TYPE });
            completionCallback();
          })
        }
      });

    }
  }
